import { render, staticRenderFns } from "./newsManage.vue?vue&type=template&id=1fba7010&"
import script from "./newsManage.vue?vue&type=script&lang=js&"
export * from "./newsManage.vue?vue&type=script&lang=js&"
import style0 from "./newsManage.vue?vue&type=style&index=0&id=1fba7010&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports